import * as yup from 'yup';
import _isEmpty from 'lodash/isEmpty';
import { Row, RenderConfig, AsyncSelect, SelectInput, NumberInput, BOOLEAN_OPTIONS } from 'commons-ui';
import { IDepResolverProps } from 'models/settingsV2.model';

const OPTIONS = [
	{ id: 'assign', label: 'assign' },
	{ id: 'remove', label: 'Remove' }
];

export const FORM_FIELD_KEYS = {
	PERMISSIONS: 'permissions',
	PERMISSIONS_SET: 'permissionsSet',
	EXPIRE_AFTER_SEC: 'expiresAt',
	IS_MASKED: 'isMasked',
	ACTIONS: 'actions'
};
export const validationSchema = yup.object().shape({
	permissions: yup.string().required('Permission is required'),
	permissionsSet: yup.string().required('Permission Set is required'),
	action: yup.string().required('Action is required')
});

const permissionsDepResolver = (props: IDepResolverProps, dependencyValues: string[]) => {
	const permissionsSetValue = dependencyValues[0];
	const { disabled } = props;
	if (!_isEmpty(permissionsSetValue) && !disabled) {
		return { disabled: true };
	}
	if (_isEmpty(permissionsSetValue) && disabled) {
		return { disabled: false };
	}
	return null;
};

const permissionsSetDepResolver = (props: IDepResolverProps, dependencyValues: string[]) => {
	const permissionsValue = dependencyValues[0];
	const { disabled } = props;
	if (!_isEmpty(permissionsValue) && !disabled) {
		return { disabled: true };
	}
	if (_isEmpty(permissionsValue) && disabled) {
		return { disabled: false };
	}
	return null;
};

const assignActionDepResolver = (props: IDepResolverProps, dependencyValues: string[]) => {
	const actionValue = dependencyValues[0];
	const { disabled } = props;

	if (actionValue === 'assign' && disabled) {
		return { disabled: false };
	}
	if (actionValue !== 'assign' && !disabled) {
		return { disabled: true };
	}
	return null;
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.PERMISSIONS),
	new Row(FORM_FIELD_KEYS.PERMISSIONS_SET),
	new Row(FORM_FIELD_KEYS.ACTIONS),
	new Row(FORM_FIELD_KEYS.EXPIRE_AFTER_SEC),
	new Row(FORM_FIELD_KEYS.IS_MASKED)
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.PERMISSIONS]: new RenderConfig()
		.setName('permissions')
		.setLabel('Select Permissions')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { bulkActions: true },
			required: true,
			multi: true,
			dependencies: ['permissionsSet'],
			dependencyResolver: permissionsDepResolver
		}),
	[FORM_FIELD_KEYS.PERMISSIONS_SET]: new RenderConfig()
		.setName('permissionsSet')
		.setLabel('Select Permission Set')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { bulkActions: true },
			required: true,
			dependencies: ['permissions'],
			dependencyResolver: permissionsSetDepResolver
		}),
	[FORM_FIELD_KEYS.ACTIONS]: new RenderConfig()
		.setName('actions')
		.setLabel('Select Action')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { bulkActions: true },
			options: OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.EXPIRE_AFTER_SEC]: new RenderConfig()
		.setName('expiresAfter')
		.setLabel('Expire After Sec')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { bulkActions: true },
			placeholder:
				'Select action to assign to enter expire after time in milliseconds i.e. 1 sec = 1,000 milliseconds (Assign Permission will expire after this duration)',
			dependencies: ['actions'],
			dependencyResolver: assignActionDepResolver,
			disabled: true
		}),
	[FORM_FIELD_KEYS.IS_MASKED]: new RenderConfig()
		.setName('isMasked')
		.setLabel('Is Masked - Assigned permission will be masked for these users')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { bulkActions: true },
			options: BOOLEAN_OPTIONS,
			placeholder: 'Select action to assign to Mask Permission Actions for these Users',
			dependencies: ['actions'],
			dependencyResolver: assignActionDepResolver,
			disabled: true
		})
};
